<footer class="mb-8">
  <div class="container mx-auto lg:px-10">
    <div class="hidden lg:block">
      <div class="flex flex-col md:flex-row md:justify-between px-4 mt-6">
        <div class="flex flex-col items-center md:items-starthidden sm:block md:block lg:block">
          <a [ngClass]="showSocial() ? '' : 'invisible'"
            [href]="this.absoluteMediaUriService.getAbsoluteMediaUri('/auction/biddingforgood.action?lp=footer_logo&cmp=ILC-b4g_run')"
            target="_self" rel="noopener noreferrer">
            <img [src]="absoluteMediaUriService.getAbsoluteMediaUri('/img/portal/BFG_FS_%20logo.png')"
              alt="Bidding For Good Logo" class="h-10 w-auto mb-2 md:mb-0">
          </a>
          <nav class="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4 mt-4">
            <a *ngFor="let link of linksLeft" [href]="link.url"
              class="text-[rgba(0,106,152,1)] text-[14px] font-normal font-mulish tracking-[0.07px] text-right opacity-100 hover:underline">
              {{ link.label }}
            </a>
          </nav>
        </div>

        <div class="flex-col items-start md:items-end  space-y-2 hidden sm:block">
          <div class="flex justify-end">
            <a href="https://www.facebook.com/biddingforgood">
              <fa-icon [icon]="icons.faFacebook" style="color: #0866ff; font-size: 24px; margin-right: 10px;"
                aria-label="Bidding For Good Facebook icon"></fa-icon>
            </a>
            <a href="https://twitter.com/biddingforgood">
              <fa-icon [icon]="icons.faXTwitter" style="color: #000000; font-size: 24px; margin-right: 10px;"
                aria-label="Bidding For Good Twitter icon"></fa-icon>
            </a>
            <a href="https://www.linkedin.com/company/biddingforgood">
              <fa-icon [icon]="icons.faLinkedin" style="color: #0077B5; font-size: 24px;"
                aria-label="Bidding For Good LinkedIn icon"></fa-icon>
            </a>
          </div>
          <nav class="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
            <a *ngFor="let link of linksRight" [href]="link.url" target="_self" rel="noopener noreferrer"
              class="text-[rgba(0,106,152,1)] text-[14px] font-normal tracking-[0.07px]  font-mulish text-right opacity-100 hover:underline">
              {{ link.label }}
            </a>
          </nav>
        </div>
      </div>
      <div class="container mx-auto  font-mulish text-xs text-center mt-4 px-4">
        &copy; {{ copyright.year }} {{ copyright.orgName }} and
        <a [href]="copyright.companyUrl" target="_self" rel="noopener" class="font-semibold">
          {{ copyright.company }}
        </a>
        <br>
        {{ copyright.message }}
      </div>
    </div>

    <div class="block lg:hidden text-center mt-12 mb-6 ">
      <p class="text-custom-blue mr-2 font-mulish font-bold">&copy; BiddingForGood.Com</p>
      <nav class="flex justify-center items-center">
        <a href="privacy-policy-url " class="text-custom-blue  mr-2 font-bold font-mulish">Privacy Policy</a>
        <a href="terms-of-use-url" class="text-custom-blue  pl-2 border-l border-blue-400 font-bold font-mulish">Terms
          of
          Use</a>
      </nav>
    </div>
  </div>
</footer>